import {createService} from "./axiosReq"
const service=createService([{key:"Content-Type",value:"multipart/form-data"}])
export function axiosReqUpload({
  url,
  data,
  method,
  isParams,
  bfLoading,
  afHLoading,
  isUploadFile,
  isDownLoadFile,
  baseURL,
  timeout,
  isAlertErrorMsg = true,
  cancelToken,
  headers,
  responseType
}) {
  if (headers) {
    service.interceptors.request.use((request) => {
      Object.keys(headers).map(key => {
        request.headers[key] = headers[key];
      })
      return request
    })
  }
  return service({
    url: url,
    method: method ?? 'get',
    data: data ?? {},
    isParams: isParams ?? false,
    bfLoading: bfLoading ?? false,
    afHLoading: afHLoading ?? true,
    isUploadFile: isUploadFile ?? false,
    isDownLoadFile: isDownLoadFile ?? false,
    isAlertErrorMsg: isAlertErrorMsg,
    baseURL: baseURL ?? import.meta.env.VITE_APP_BASE_URL,
    timeout: timeout ?? 15000,
    cancleToken: cancelToken,
    responseType: responseType
  });
}
export default axiosReqUpload;
